// @ vendors
const React = require('react');
import PropTypes from 'prop-types';
// @ helpers
const { getPublicSiteUrl } = require('core/apiURLBuilder');
// @components
const { LoadingSection } = require('commonsComponents/loadingSection');

class NotFoundView extends React.Component {
    componentDidMount() {
        if (!this.props.notFoundViewPrivate) window.location.href = getPublicSiteUrl() + '/page_404';
    }

    render() {
        if (!this.props.notFoundViewPrivate) {
            return <LoadingSection />;
        }
        return (
            <video autoPlay height="auto" loop width="100%" muted="">
                <source src={`${getPublicSiteUrl(false)}/assets/static/404/404_ok_8.mp4`} type="video/mp4" />
                <source src={`${getPublicSiteUrl(false)}/assets/static/404/404_ok_8.webm`} type="video/webm" />
            </video>
        )
    }
}

NotFoundView.propTypes = {
    notFoundViewPrivate: PropTypes.bool
};

NotFoundView.defaultPropTypes = {
    notFoundViewPrivate: false
};

module.exports = NotFoundView;
